/*
* Prestige Theme
*
* Use this file to add custom Javascript to Prestige. Keeping your custom
* Javascript in this fill will make it easier to update Prestige. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById("product-channels-modal");
    if (!modal) return;

    const openers = document.querySelectorAll('a[href="#where-to-buy"]');
    const closeBtn = document.getElementById("modal-content-close");
    const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let lastFocused = null;

    function openModal(event) {
      if (event) event.preventDefault();
      lastFocused = document.activeElement;
      modal.classList.add("modal-open");
      document.body.classList.add("modal-open");
      modal.setAttribute("aria-hidden", "false");
      const first = modal.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function closeModal() {
      modal.classList.remove("modal-open");
      document.body.classList.remove("modal-open");
      modal.setAttribute("aria-hidden", "true");
      if (lastFocused) lastFocused.focus();
    }

    openers.forEach((btn) => btn.addEventListener("click", openModal));
    if (closeBtn) closeBtn.addEventListener("click", closeModal);

    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") { closeModal(); return; }
      if (event.key !== "Tab") return;
      const items = Array.from(modal.querySelectorAll(FOCUSABLE))
        .filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
  });
})();